import React from 'react';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const CustomIcon = styled(({ icon, ...props }) =>
  React.cloneElement(icon, props),
)`
  svg {
    width: ${spacing(5)};
    height: ${spacing(5)};
  }
`;
